import { render, staticRenderFns } from "./Consultation-sh.vue?vue&type=template&id=155b329c&scoped=true"
import script from "./Consultation-sh.vue?vue&type=script&lang=js"
export * from "./Consultation-sh.vue?vue&type=script&lang=js"
import style0 from "./Consultation-sh.vue?vue&type=style&index=0&id=155b329c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155b329c",
  null
  
)

export default component.exports